import { observable } from 'mobx';

/**
 * Базовый класс связи между моделями
 */
export default class Relation {

	/**
	 * Соответствие клиентского и серверного API методов для связей
	 */
	static METHODS = {
	//	'fromName':		'toName'
		'link':			'add',
		'unlink':		'remove',
		'get':			'find',
		'findById':		'findById',
		'exists':		'exists',
		'count':		'count',
		'create':		'create',
		'delete':		'destroy',
		'destroyById':	'destroyById',
		'updateById':	'updateById',
	};

	/**
	 * Модель к которой относится связь
	 */
	_model;

	/**
	 * Модель на которую указывает связь
	 */
	_targetModel;

	/**
	 * Связь содержит информацию о типе связи и ключах
	 */
	_relation;

	/**
	 * Экземпляр объекта к которому относится связь
	 * Если null - то связь относится к модели в целом, а не объекту модели
	 */
	@observable _instance;

	constructor (model, targetModel, relation, instance) {
		this._model = model;
		this._targetModel = targetModel;
		this._relation = relation;
		this._instance = instance;
	}

	/**
	 * Очистка кэша связи, определяется наследником, по умолчанию ничего не делает
	 */
	clearCache () {
	}
}